import { createMixpanelEvent } from '../../../../../shared/utils/events/mixpanel/events/base';
import { CollectionsLobbyEventTypes } from '../types';

const { pageView, header, collectionCard, viewFilter, emptyView, modals } = CollectionsLobbyEventTypes;

export const CollectionsLobbyMixpanelEvents = {
    [pageView]: createMixpanelEvent(),

    [header.actions.createCollection.clicked]: createMixpanelEvent('Collections Lobby - Create Collection - clicked'),

    [collectionCard.clicked]: createMixpanelEvent('Collections Lobby - Collection Card - clicked'),
    [collectionCard.actions.shareWithTeam.clicked]: createMixpanelEvent(
        'Collections Lobby - Collection Card - action clicked'
    ),
    [collectionCard.actions.socialShare.clicked]: createMixpanelEvent(
        'Collections Lobby - Collection Card - action clicked'
    ),
    [collectionCard.actions.edit.clicked]: createMixpanelEvent('Collections Lobby - Collection Card - action clicked'),
    [collectionCard.actions.delete.clicked]: createMixpanelEvent(
        'Collections Lobby - Collection Card - action clicked'
    ),

    [viewFilter.changed]: createMixpanelEvent('Collections Lobby - View Filter - changed'),
    [emptyView.actions.createCollection.clicked]: createMixpanelEvent(
        'Collections Lobby - Empty Create Collection - clicked'
    ),

    [modals.createCollection.show]: createMixpanelEvent('Create Collection Modal - show'),
    [modals.createCollection.cancel]: createMixpanelEvent('Create Collection Modal - cancel'),
    [modals.createCollection.submit]: createMixpanelEvent('Create Collection Modal - submit'),
    [modals.createCollection.fail]: createMixpanelEvent('Create Collection Modal - fail'),
};
